var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#008CFF",
    d: "M12.141 13.394l4.102-4.101a1 1 0 011.414 1.414l-4.95 4.95a1 1 0 01-1.414 0l-4.95-4.95a1 1 0 011.414-1.414l4.102 4.101a.2.2 0 00.282 0z"
  })));
}
export default SvgDownBlue;